import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../components/SidebarDashboard";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { Link, useHistory } from "react-router-dom";
//Tabla, Navbar y Sidebar
//import CustomTable from "../../../components/CustomTable";
//import CustomPagint from "../../../components/CustomPagint";
//import messages from "../../../redux/messages";
import CustomNavbar from "../../components/CustomNavbar";
import userperfil from "../../images/userperfil.png";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import {
  getNotifications,
  saveNotifications,
  editNotifications,
  deleteNotification,
  notificationsRead,
} from "../../redux/notifications/actions";

const Notifications = (props) => {
  const [show, setShow] = useState(true);
  const [_selectAsunto, setSelectAsunto] = useState("");
  const history = useHistory();
  const onShowSidebar = () => setShow(show ? false : true);
  const dispatch = useDispatch();
  const { userType, id, name } = useSelector((store) => store.auth);
  const { ficha_empleado, loadingFicha_Empleado } = useSelector(
    (store) => store.funcTabEmployeed
  );
  const {
    loaderNotifications,
    notifications,
    notificationsFail,
    saveLoaderNotifications,
    notificationsFormError,
  } = useSelector((store) => store.notifications);

  const [mensajeSeleccionado, setmensajeSeleccionado] = useState("");
  const [asuntoSeleccionado, setAsuntoSeleccionado] = useState("");
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [mensajeSeleccionadoId, setmensajeSeleccionadoId] = useState(0);
  const [idSeleccionado, setIdSeleccionado] = useState(0);
  const [enlace, setEnlace] = useState("");

  /*
  useEffect(() => {
    if (id) {
      dispatch(
        getNotifications({
          id_destinatario: parseInt(13900), //dejarlo como id luego
        })
      );
    }
  }, [dispatch]);
*/

  useEffect(() => {
    if (userType) {
      dispatch(getFuncFichaEmpleado(id, parseInt(userType)));
    }

    if (id && id !== "") {
      dispatch(
        getNotifications({
          id_destinatario: parseInt(id),
        })
      );
    }
  }, [dispatch, id, userType]);

  useEffect(() => {
    if (
      notifications &&
      notifications.count > 0 &&
      props.match.params.idNotificaciones
    ) {
      let notificacionActual = notifications.data.find(
        (n) => n.id === parseInt(props.match.params.idNotificaciones)
      );
      setIdSeleccionado(notificacionActual.id);
      setmensajeSeleccionado(notificacionActual.mensaje);
      setAsuntoSeleccionado(notificacionActual.asunto);
      setFechaSeleccionada(notificacionActual.fecha_creacion);
      setEnlace(notificacionActual.enlace);
    }
  }, [notifications]);

  const mostrarMensaje = (mensaje, asunto, fecha, enlace) => (
    <>
      <hr />
      <h6> {asunto}</h6>
      <h6> Fecha recibido: {moment(fecha).format("DD/MM/YYYY")}</h6>
      <label className="mb-3 py-2"> {mensaje} </label>
      <a href={enlace ? enlace : ""} target="_blank" rel="noreferrer"> {enlace} </a>
    </>
  );

  return (
    <>
      <div className="container mt-5 mb-3">
        <div className="d-flex justify-content-between align-items-center my-5">
          <Col md="12" className="px-0 align-item-right">
            <div className="d-flex justify-content-between align-items-center my-5">
              <p className="text-uppercase font-weight-bold">
                Vista general de notificaciones
              </p>

              <Button
                className="rounded-pill"
                onClick={() => {
                  getNotifications({
                    limit: 10,
                    offset: 0,
                    id_destinatario: parseInt(id),
                    leido: 0,
                  });
                  history.push(`/detalle-empleado/${id}/${userType}`);
                }}
                variant="warning"
                size="sm"
                type="button"
              >
                Regresar
              </Button>
            </div>
            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 mx-3 d-flex flex-wrap justify-content-start align-items-center">
              <Row>
                <Col sm="2" md="2">
                  {/* img src={`${ props.data.foto && data.foto !== '' ?  props.data.foto : userperfil}`} className="shadow image-avatar-dashboard-user" alt="pic" /> */}
                  <img
                    src={
                      ficha_empleado.foto
                        ? `${process.env.REACT_APP_URL}/media/${ficha_empleado.foto}`
                        : userperfil
                    }
                    style={{ width: "100%" }}
                    className="rounded shadow"
                    alt="User perfil"
                  />
                </Col>
                <Col sm="6" md="6">
                  <h3 className="font-weight-bold text-uppercase ">{name}</h3>
                </Col>
                <Col sm="12" md="12">
                  <Row>
                    <p className="text-uppercase font-weight-bold p-3 m-2">
                      Notificaciones
                    </p>
                  </Row>
                </Col>

                <Col className="px-2" sm="12" md="12">
                  {loaderNotifications ? (
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-center"
                    />
                  ) : (
                    <Row>
                      <Col
                        className=" rounded shadow-sm "
                        style={{ overflowY: " auto", height: "400px" }}
                        sm="3"
                        md="3"
                      >
                        <h6 className="mb-2">Asunto</h6>
                        {notifications &&
                          notifications.count > 0 &&
                          notifications.data.map((item, index) => (
                            <>
                              <div
                              // className={
                              //   idSeleccionado === item.id
                              //     ? ""
                              //     : ""
                              // }
                              >
                                <label
                                  onClick={() => {
                                    history.push(`/notificaciones/${item.id}`);
                                    setIdSeleccionado(item.id);
                                    setmensajeSeleccionado(item.mensaje);
                                    setAsuntoSeleccionado(item.asunto);
                                    setFechaSeleccionada(item.fecha_creacion);
                                    setEnlace(item.enlace);
                                    dispatch(
                                      notificationsRead(
                                        item.id,
                                        {
                                          leido: true,
                                        },
                                        index
                                      )
                                    );
                                    // console.log("holi");
                                  }}
                                  style={{ cursor: "pointer" }}
                                  key={item.id}
                                >
                                  {/* {item.asunto} */}
                                  <div
                                    className={`${
                                      item.leido ? "" : "bg_no_leido"
                                    } mb-2 ${
                                      idSeleccionado === item.id
                                        ? "bg_seleccionado"
                                        : ""
                                    }`}
                                  >
                                    {item.asunto}
                                  </div>
                                </label>
                                <hr
                                  size="2px"
                                  width="80%"
                                  noshade="noshade"
                                  align="left"
                                />
                              </div>
                            </>
                          ))}
                      </Col>
                      <Col sm="9" md="9">
                        <h6 className="mb-3">Mensaje</h6>
                        {mensajeSeleccionado.trim().length > 0 &&
                        asuntoSeleccionado.trim().length > 0
                          ? mostrarMensaje(
                              mensajeSeleccionado,
                              asuntoSeleccionado,
                              fechaSeleccionada,
                              enlace
                            )
                          : mostrarMensaje("Seleccione un asunto")}
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </div>
      </div>
    </>
  );
};

export default Notifications;
